import {
    PlannedWorkShiftDto,
    PlannedWorkShiftQueryParameters,
    PlannedWorkShiftSaveDto,
    PlannedWorkShiftsPublishDto,
    PlannedWorkShiftUpdateStateDto,
} from "../models/plannedWorkShift/plannedWorkShift";
import { apiCall } from "./apiClient";

export const getPlannedWorkShifts = async(
    params: PlannedWorkShiftQueryParameters,
    signal?: AbortSignal
) => {
    const response = await apiCall<
        PlannedWorkShiftDto[],
        PlannedWorkShiftQueryParameters
    >("PlannedWorkShifts", "GET", params, signal);
    return response.data;
};

export const getPlannedWorkShift = async(id: string) => {
    const response = await apiCall<PlannedWorkShiftDto>(
        `PlannedWorkShifts/${id}`,
        "GET"
    );
    return response.data;
};

export const savePlannedWorkShift = async(data: PlannedWorkShiftSaveDto) => {
    const response = await apiCall<PlannedWorkShiftDto>(
        "PlannedWorkShifts",
        "POST",
        data
    );
    return response.data;
};

export const deletePlannedWorkShift = async(id: string) => {
    return await apiCall<void>(`PlannedWorkShifts/${id}`, "DELETE");
};

export const updatePlannedWorkShiftsState = async(
    dtos: PlannedWorkShiftUpdateStateDto[]
) => {
    return await apiCall<void>("PlannedWorkShifts/state", "PUT", dtos);
};

export const publishPlannedWorkShifts = async(dto: PlannedWorkShiftsPublishDto) => {
    return await apiCall<void>("PlannedWorkShifts/publish", "POST", dto);
};
